import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export interface CheckInStatusBadgeProps {
  checkedInDate?: string | null;
  /** When true, shows the check-in date inline next to the badge */
  showDate?: boolean;
}

export const CheckInStatusBadge = ({
  checkedInDate,
  showDate = false,
}: CheckInStatusBadgeProps): ReactElement => {
  if (!checkedInDate) {
    return (
      <Typography
        sx={{
          fontFamily: 'Poppins, sans-serif',
          fontSize: '12px',
          fontWeight: 600,
          lineHeight: '18px',
          color: '#a7a7a7',
          textTransform: 'uppercase',
          letterSpacing: 0,
        }}
      >
        Not Checked In
      </Typography>
    );
  }

  const formattedDate = new Date(checkedInDate).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return (
    <Box display="flex" alignItems="center" gap="8px" flexWrap="wrap">
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px',
          backgroundColor: '#00ad0b',
          borderRadius: '9999px',
          px: '9px',
          py: '4px',
          flexShrink: 0,
        }}
      >
        <CheckIcon sx={{ fontSize: '13.578px', color: '#ffffff' }} />
        <Typography
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '18px',
            color: '#ffffff',
            textTransform: 'uppercase',
            letterSpacing: 0,
            whiteSpace: 'nowrap',
          }}
        >
          Checked In
        </Typography>
      </Box>
      {showDate && (
        <Typography
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            color: '#4a5565',
            whiteSpace: 'nowrap',
          }}
        >
          {formattedDate}
        </Typography>
      )}
    </Box>
  );
};
